import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { logoutConfirmation } from '../../pages/common/Utils';

export default function Sidebar() {
    
    const location = useLocation();
    const [adminProfile, setAdminProfile] = useState({
        role: localStorage.getItem('role') ?? 0,
        user_id: localStorage.getItem('user_id') ?? 0,
        name: localStorage.getItem('name') ?? 0,
        email: localStorage.getItem('email') ?? 0,
        country_code: localStorage.getItem('country_code') ?? 0,
        phone: localStorage.getItem('phone') ?? 0,
        profile_image: localStorage.getItem('profile_image') === 'default.png' ? process.env.PUBLIC_URL + "/logo.png" : localStorage.getItem('profile_image'),
    });

    useEffect(() => {
    }, []);

    const isMenuActive = (menu) => {
        const extracted = location.pathname.split('/');
        return extracted[1] === menu;
    };

    const isSubMenuActive = (menu) => {
        const extracted = location.pathname.split('/');
        return extracted[2] === menu;
    };

    return (
        <>
            <aside id="leftsidebar" className="sidebar">
                <div className="user-info">
                    <div className="image">
                        <img
                            src={adminProfile.profile_image}
                            style={{ height: '48px', width: '48px', objectFit: 'contain' }}
                            alt="Profile"
                        />
                    </div>
                    <div className="info-container">
                        <div className="name" data-toggle="dropdown">
                            {adminProfile.name}
                        </div>
                        <div className="btn-group user-helper-dropdown">
                            <i
                            className="material-icons"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="true"
                            role="button"
                            >
                            {" "}
                            keyboard_arrow_down{" "}
                            </i>
                            <ul className="dropdown-menu slideUp">
                                <li>
                                    <a href="/authpanel/profile">
                                        <i className="material-icons">person</i>Profile
                                    </a>
                                </li>
                                <li className="divider" />
                            </ul>
                        </div>
                        <div className="email">{adminProfile.country_code + adminProfile.phone}</div>
                    </div>
                </div>
                <div className="menu">
                    <ul className="list">
                        <li className={
                                
                                isMenuActive("dashboard") ? "active open" : "has-submenu open"
                            }>
                            <a href="/authpanel/dashboard">
                                <i className="zmdi zmdi-home zmdi-hc-fw"></i>
                                <span>Dashboard</span>{" "}
                            </a>
                        </li>
                        <li className={isMenuActive("users") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/users/listing">
                                <i className="zmdi zmdi-accounts zmdi-hc-fw"></i>
                                <span>Users</span>{" "}
                            </a>
                        </li>
                        <li className={isMenuActive("orders") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/orders/listing">
                                <i className="zmdi zmdi-shopping-cart-plus zmdi-hc-fw"></i>
                                <span>Orders</span>{" "}
                            </a>
                        </li>
                        <li className={isMenuActive("deposit-withdrawal") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/deposit-withdrawal/listing">
                                <i className="zmdi zmdi-money-box zmdi-hc-fw"></i>
                                <span>Deposit/Withdrawals</span>{" "}
                            </a>
                        </li>
                        <li className={isMenuActive("earnings") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/earnings/listing">
                                <i className="zmdi zmdi-money zmdi-hc-fw"></i>
                                <span>Earnings</span>{" "}
                            </a>
                        </li>
                        <li className={isMenuActive("reports") ? "active open collapsable-li" : "has-submenu open collapsable-li"}> 
                            <a href="#" className="menu-toggle toggled waves-effect waves-block">
                                <i className="zmdi zmdi-chart zmdi-hc-fw"></i>
                                <span>Reports</span>
                            </a>
                            <ul className="ml-menu" style={{ display: 'block' }}>
                                <li className={isSubMenuActive("top-funded-accounts") ? "active" : ""}>
                                    <a href="/authpanel/reports/top-funded-accounts" className="">Top Funded Accounts</a> 
                                </li>
                                <li className={isSubMenuActive("top-trading-stocks") ? "active" : ""}>
                                    <a href="/authpanel/reports/top-trading-stocks" className="">Top Trading Stocks</a> 
                                </li>
                                <li className={isSubMenuActive("account-metrics") ? "active" : ""}>
                                    <a href="/authpanel/reports/account-metrics" className="">Account Metrics</a> 
                                </li>
                                <li className={isSubMenuActive("closed-positions") ? "active" : ""}>
                                    <a href="/authpanel/reports/closed-positions" className="">Closed Positions</a> 
                                </li>
                            </ul>
                        </li>
                        <li className={isMenuActive("notifications") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/notifications/listing">
                                <i className="zmdi zmdi-notifications-active zmdi-hc-fw"></i>
                                <span>Notifications</span>{" "}
                            </a>
                        </li>
                        <li className={isMenuActive("contactus") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/contactus/listing">
                                <i className="zmdi zmdi-star zmdi-hc-fw"></i>
                                <span>Contact Us</span>
                            </a>
                        </li>
                        <li className={isMenuActive("faqs") ? "active open" : "has-submenu open"}>
                            <a href="/authpanel/faqs/listing">
                                <i className="zmdi zmdi-help zmdi-hc-fw"></i>
                                <span>FAQ's</span>
                            </a>
                        </li>
                        <li className={isMenuActive("app-content") ? "active open collapsable-li" : "has-submenu open collapsable-li"}> 
                            <a href="#" className="menu-toggle toggled waves-effect waves-block">
                                <i className="zmdi zmdi-format-list-bulleted zmdi-hc-fw"></i>
                                <span>CMS Content</span>
                            </a>
                            <ul className="ml-menu" style={{ display: 'block' }}>
                                <li className={isSubMenuActive("about-us") ? "active" : ""}>
                                    <a href="/authpanel/app-content/about-us" className="">About Us</a> 
                                </li>
                                <li className={isSubMenuActive("privacy-policy") ? "active" : ""}>
                                    <a href="/authpanel/app-content/privacy-policy" className="">Privacy Policy</a> 
                                </li>
                                <li className={isSubMenuActive("terms-of-use") ? "active" : ""}>
                                    <a href="/authpanel/app-content/terms-of-use" className="">Terms of Use</a> 
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </aside>
        </>
    );
}